import React from "react";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import { serviceCaller, ServiceCallerProps } from "../../../composition";

import { ContentState } from "draft-js";
import ReactTooltip from "react-tooltip";
import Fragment from "../../../../toolkit/fragment";
import * as s from "./link.scss";

interface Props extends ServiceCallerProps {
  entityKey: string;
  contentState: ContentState;
  children: React.ReactNode;
  onEdit: (string) => void;
  onRemove: (string) => void;
}

interface State {}

class LinkDecorator extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  onEditClick = (entityKey: string) => () => {
    this.props.onEdit(entityKey);
  };

  onDeleteClick = (entityKey: string) => () => {
    this.props.onRemove(entityKey);
  };

  render() {
    const { entityKey, contentState, children } = this.props;
    const { url } = contentState.getEntity(entityKey).getData();
    return (
      <Fragment>
        <span
          data-tip={`tooltip-${entityKey}`}
          data-for={`tooltip-${entityKey}`}
        >
          <i className="fa fa-link" />
          <span className={s.anchorText}>{children}</span>
        </span>
        <ReactTooltip
          id={`tooltip-${entityKey}`}
          type="dark"
          place="bottom"
          effect="solid"
          delayHide={500}
          clickable={true}
        >
          <span>{url}</span>&nbsp;
          <span>|</span>&nbsp;
          <a onClick={this.onEditClick(entityKey)}>Change</a>&nbsp;
          <span>|</span>&nbsp;
          <a onClick={this.onDeleteClick(entityKey)}>Remove</a>
        </ReactTooltip>
      </Fragment>
    );
  }
}

export default serviceCaller(
  connect(
    () => ({}),
    () => ({})
  )(withStyles(s)(LinkDecorator))
);
